import {z} from 'zod';

export default z.object({
    playlist: z.array(z.object({
        url: z.string(),
        title: z.string().optional(),
    })),
})
